export const evaluation = {
    NewEvaluation: {
        name: '新高考选科测评',
        parent: '新高考选科测评'
    },
    Major: {
        name: '根据科目选专业',
        parent: '新高考选科测评'
    },
    Subject: {
        name: '根据专业选科目',
        parent: '新高考选科测评'
    },
    Entrance: {
        name: '升学途径分析测评',
        parent: '升学规划测评'
    },
    Guide: {
        name: '升学途径指南',
        parent: '升学规划测评'
    },
    Style: {
        name: '学习风格测评',
        parent: '学业规划测评'
    },

    LearningTime: {
        name: '学业时间管理测评',
        parent: '学业规划测评'
    },
    Psychological: {
        name: '学业心理调节测评',
        parent: '学业规划测评'
    },
    EmotionManage: {
        name: '学业情绪管理测评',
        parent: '学业规划测评'
    },
    Comprehensive: {
        name: '学习态度、方法和能力综合测评',
        parent: '学业规划测评'
    },
    Habit: {
        name: '学习习惯测评',
        parent: '学业规划测评'
    },
    Motivation: {
        name: '学习动机诊断测评',
        parent: '学业规划测评'
    },
    StudySarason: {
        name: 'Sarason考试焦虑测评',
        parent: '学业规划测评'
    },
    Relationship: {
        name: '师生和同学关系测评',
        parent: '学业规划测评'
    },
    Orientation: {
        name: '专业定位测评',
        parent: '职业规划测评'
    },
    ShiEn: {
        name: '施恩职业锚测评',
        parent: '职业规划测评'
    },
    Temperament: {
        name: '气质测评',
        parent: '职业规划测评'
    },
    Shubo: {
        name: '舒伯职业价值观测评',
        parent: '职业规划测评'
    },
    Usability: {
        name: '心理适应性测评',
        parent: '职业规划测评'
    },
    Confidence: {
        name: '自信心测评',
        parent: '职业规划测评'
    },
    EQ: {
        name: 'EQ情商测评',
        parent: '职业规划测评'
    },
    DISC: {
        name: 'DISC个性测评',
        parent: '职业规划测评'
    },
    ProfessionalPDP: {
        name: 'PDP性格测评',
        parent: '职业规划测评'
    },
    ArchivesPDP: {
        name: '学生学情档案',
        parent: '学生学情档案'
    },
    ParentPDP: {
        name: '家长情况测评',
        parent: '家长情况测评'
    },
    UniversityScore: {
        name: '查:高校分数线',
        parent: '高效查'
    },
    MajorScore: {
        name: '查:专业分数线',
        parent: '高效查'
    },
    Provincial: {
        name: '查:省控分数线',
        parent: '高效查'
    },
    Paragraph: {
        name: '查:一分一段表',
        parent: '高效查'
    },
    University: {
        name: '查:高校查询',
        parent: '高效查'
    },
    UniversityRank: {
        name: '查:大学排名',
        parent: '高效查'
    },
    ProfessionalInquiry: {
        name: '查:专业查询',
        parent: '高效查'
    },
    OccupationInquiry: {
        name: '查:职业查询',
        parent: '高效查'
    },
    Admission: {
        name: '查:招生章程',
        parent: '高效查'
    },
    Colleges: {
        name: '填:智能选院校',
        parent: '精准填'
    },
    MajorSelect: {
        name: '填:智能选专业',
        parent: '精准填'
    },
    AdmissionRisk: {
        name: '填:录取风险评估',
        parent: '精准填'
    },
    Whereabout: {
        name: '填:同分数考生去向',
        parent: '精准填'
    },
    Voluntary: {
        name: '填:一键志愿填报',
        parent: '精准填'
    },
	FamilyStudy:{
		name:'家庭学习与支持测评',
		parent:'家庭教育测评'
	},
	ParentChildRelationship:{
		name:'亲子关系测评',
		parent:'家庭教育测评'
	},
	FamilyEnvironment:{
		name:'家庭环境测评',
		parent:'家庭教育测评'
	},
	FamilyFunction:{
		name:'家庭功能测评',
		parent:'家庭教育测评'
	},
	TeenagerAddicted:{
		name:'青少年上瘾自评测评',
		parent:'家庭教育测评'
	},
	
}
